import React, { useEffect, useState } from "react";
import { API_URL } from "../../config";
import { Card, Row, Col, Input, Button } from "antd";
import {
  FireOutlined,
  HeartOutlined,
  BoldOutlined,
  UploadOutlined,
  DownloadOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import PatientsContainer from "./PatientsContainer";
import moment from "moment";
import axios from "axios";
import images from "../../components/common/images/images";
import { useTranslation } from "react-i18next";

const { TextArea } = Input;

const PatientDetails = ({ patient }) => {
  const patient_id = patient.patient_id;

  const [consultationNotes, setConsultationNotes] = useState([]);
  const [showPatients, setShowPatients] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showAllergies, setShowAllergies] = useState(false);
  const [responses, setResponses] = useState(null);
  const filteredNotes = consultationNotes.filter((note) =>
    note.contents.toLowerCase().includes(searchQuery.toLowerCase()),
  );
  const { t } = useTranslation();

  const formatContents = (contents) => {
    const lines = contents.split("\n");
    let formattedLines = [];
    const numberedItemRegex = /^(\d+\))\s?(.*)/;

    lines.forEach((line, index) => {
      const match = line.match(numberedItemRegex);
      if (match) {
        formattedLines.push(
          <span key={index}>
            <strong>{match[1]}</strong> {match[2]}
          </span>,
        );
      } else {
        formattedLines.push(<span key={index}>{line}</span>);
      }
      formattedLines.push(<br key={`br-${index}`} />);
    });

    return formattedLines;
  };

  useEffect(() => {
    axios
      .get(`${API_URL}/user/patients/${patient_id}/notes/`)
      .then((response) => {

        const filteredNotes = response.data.notes.filter(
          (note) => note.title && note.contents,
        );
        setConsultationNotes(filteredNotes);
        setResponses(response.data.notes);
      })
      .catch((error) => {
        console.error("Error fetching past consultation notes:", error);
      });
  }, [patient_id]);
  let doctorName;

  let phone_number;

  if (
    consultationNotes &&
    consultationNotes.length > 0 &&
    consultationNotes[0].doctor
  ) {
    const firstDoctor = consultationNotes[0].doctor;
    phone_number = `${firstDoctor.phone_number}`;
    doctorName = `${firstDoctor.salutation} ${firstDoctor.first_name} ${firstDoctor.last_name}`;
    
  } else {
    console.log("No doctor information available.");
  }

  function calculateAge(dob) {
    const birthDate = new Date(dob);
    const difference = Date.now() - birthDate.getTime();
    const ageDate = new Date(difference);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  const patientData = {
    name: `${patient.first_name} ${patient.last_name}`,
    id: patient.patient_id,
    gender: patient.gender,
    age: calculateAge(patient.date_of_birth) + " years old",
    email: patient.email_address,
    contact: patient.phone_number,
    allergies: patient.allergies,
    image: images.loginUser,
  };
  console.log(patientData.allergies);

  const getDoctorData = () => {
    let defaultDoctorData = {
      name: "-",
      hospital: "-",
      registrationNo: "-",
      specialities: "-",
      contact: "-",
      image: "https://via.placeholder.com/70",
      note: "No notes available",
    };

    if (consultationNotes.length > 0) {
      return {
        name: doctorName,
        hospital: "ABC Hospital",
        registrationNo: "M123-232",
        specialities: "Family Physician",
        contact: phone_number,
        image: images.loginUser,
        note: "High fever. Rest for 3 days.",
      };
    }

    return defaultDoctorData;
  };

  const doctorData = getDoctorData();

  const vitalSigns = [
     { title: t("vitalSigns.bloodPressure"), value: "120 / 80 mmHg", icon: <BoldOutlined /> },
     { title: t("vitalSigns.heartRate"), value: "84 bpm", icon: <HeartOutlined /> },
     { title: t("vitalSigns.temperature"), value: "36°C", icon: <FireOutlined /> },
     { title: t("vitalSigns.spo2"), value: "98%", icon: <SwapOutlined /> },
     { title: t("vitalSigns.height"), value: "160 cm", icon: <UploadOutlined /> },
     { title: t("vitalSigns.weight"), value: "60 kg", icon: <DownloadOutlined /> }
  ];

  const handleClick = () => {
    setShowPatients(!showPatients);
  };

  return (
    <>
      {!showPatients && (
        <div
          style={{
            padding: "20px",
            backgroundColor: "#fff8dc",
            fontSize: "200px",
          }}
        >
          <Row gutter={16}>
            <Col span={8}>
              <Card bordered={false} style={{ backgroundColor: "#fff8dc" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",

                    padding: "20px",
                    backgroundColor: "#fff8dc",
                  }}
                >
                  <img
                    src={patientData.image}
                    alt="Patient"
                    style={{
                      height: "250px",
                      width: "250px",
                      alignItems: "center",
                      borderRadius: "50%",
                      objectFit: "cover",
                      marginBottom: "20px",
                    }}
                  />
                  <h3>{patientData.name}</h3>

                  <p>
                    <b>{t("tableHeader.gender")}:</b> {patientData.gender}
                  </p>
                  <p>
                    <b>{t("tableHeader.age")}:</b> {patientData.age}
                  </p>
                  <p>
                    <b>{t("doctor.emailAddress")}:</b> {patientData.email}
                  </p>
                  <p>
                    <b>{t("doctor.phoneNumber")}:</b> {patientData.contact}
                  </p>
                  <Button
                    type="primary"
                    style={{ marginTop: "10px" }}
                    onClick={() => setShowAllergies(!showAllergies)}
                  >
                    {t("patientPage.addAllergy")}
                  </Button>

                  {showAllergies && (
                    <div style={{ marginTop: "10px" }}>
                      <h3>{t("patientPage.addAllergy")}</h3>
                      {patientData.allergies.length > 0 ? (
                        patientData.allergies.map((allergy, index) => (
                          <div key={index}>
                            <Row>
                              <Col></Col>
                              <Col></Col>
                            </Row>
                            <p>
                              <strong>{t("patientPage.allergyType")}:</strong>{" "}
                              {allergy.allergy_type || "-"}
                            </p>
                            <p>
                              <strong>{t("patientPage.allergy")}:</strong>{" "}
                              {allergy.allergy || "-"}
                            </p>
                            <p>
                              <strong>{t("patientPage.reaction")}:</strong>{" "}
                              {allergy.reaction || "-"}
                            </p>
                            <p>
                              <strong>{t("patientPage.severity")}:</strong>{" "}
                              {allergy.severity || "-"}
                            </p>
                          </div>
                        ))
                      ) : (
                        <p>{t("patientPage.noKnownDrugAllergy")}</p>
                      )}
                    </div>
                  )}
                </div>
              </Card>
              <Row>
                <Button onClick={handleClick} style={{ marginTop: "5%" }}>
                  {t("patientPage.backPatientDetails")}
                </Button>
              </Row>
            </Col>

            <Col span={8}>
              <Card
                bordered={false}
                style={{ backgroundColor: "white", marginTop: "5%" }}
              >
                <Row>
                  <Col span={6}>
                    <img
                      src={doctorData.image}
                      alt="Doctor"
                      style={{
                        height: "80px",
                        width: "80px",
                        borderRadius: "50%",
                        objectFit: "cover",
                        margin: "22%",
                      }}
                    />
                  </Col>
                  <Col span={18}>
                    <h4 style={{ fontSize: "18px" }}>{doctorData.name}</h4>
                    <p style={{ fontSize: "16px" }}>
                      {t("doctor.clinic")} / {t("doctor.hospital")}:{" "}
                      {doctorData.hospital}
                    </p>
                    <p style={{ fontSize: "16px" }}>
                      {t("doctor.medicalRegistration")}:{" "}
                      {doctorData.registrationNo}
                    </p>
                    <p style={{ fontSize: "16px" }}>
                      {t("doctor.specialties")}: {doctorData.specialities}
                    </p>
                    <p style={{ fontSize: "16px" }}>
                      {t("doctor.phoneNumber")}: {doctorData.contact}
                    </p>
                  </Col>
                </Row>
              </Card>

              <Row gutter={16}>
                <Col span={24}>
                  <Card
                    title={t("doctor.doctorNote")}
                    className="doctor-note"
                    style={{ backgroundColor: "#fff8dc" }}
                  >
                    <TextArea
                      rows={4}
                      placeholder="High fever. Rest for 3 days."
                      disabled
                      style={{
                        backgroundColor: "#fff8dc",
                        color: "grey",
                      }}
                    />
                    <style>
                      {`
          .doctor-note textarea::placeholder {
            color: 'grey';
          }
        `}
                    </style>
                  </Card>
                </Col>
              </Row>

              <Card
                title={t("patientPage.vitalSigns")}
                style={{ marginTop: "20px", backgroundColor: "#fff8dc" }}
              >
                <Row gutter={16}>
                  {vitalSigns.map((sign, index) => (
                    <Col span={12} key={index}>
                      <Card
                        className="vital-sign-card"
                        bordered={false}
                        style={{ backgroundColor: "#f0f8ff" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            <p style={{ fontSize: "12px" }}>{sign.title}</p>
                            <p style={{ fontSize: "12px" }}>{sign.value}</p>
                          </div>
                          {sign.icon}
                        </div>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Card>
            </Col>

            <Col span={8}>
              <Card
                title={t("patientPage.pastAppointments")}
                style={{
                  backgroundColor: "#e6ffe6",
                  height: filteredNotes.length === 0 ? "200px" : "800px",
                  overflowY: "auto",
                  marginTop: filteredNotes.length === 0 ? "60%" : "5%",
                }}
              >
                {filteredNotes.length === 0 ? (
                  <p>{t("patientPage.noNote")}</p>
                ) : (
                  filteredNotes.map((note, index) => (
                    <Card key={index} style={{ marginBottom: "16px" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <p style={{ margin: 0, wordWrap: "break-word" }}>
                          {formatContents(note.contents)}
                        </p>
                      </div>
                      <Row justify="end" align="middle">
                        <Col>
                          {note.doctor?.first_name && note.doctor?.last_name ? (
                            <p>{`${note.doctor.first_name} ${note.doctor.last_name}`}</p>
                          ) : (
                            ""
                          )}
                          {moment(note.last_modified).format("DD/MM/YYYY LT")}
                        </Col>
                      </Row>
                    </Card>
                  ))
                )}
              </Card>
            </Col>
          </Row>
        </div>
      )}
      {showPatients && <PatientsContainer />}
    </>
  );
};

export default PatientDetails;
